import Stories from './Stories-Container';

export default Stories;
